import { AbstractHistogram } from 'hdr-histogram-js'
import { layersPhpResponseTime } from '../Layers'
import { Report } from '../Report'

export interface DateRangeTrend {
    range: { startDate: string; endDate: string }
    errorRate: number
    requests: number
    crawlers: number
    pageCache: { hits: number; misses: number }
    responseTime: number
    averageResponseTime: number
    phpResponseTime: number
    maxMemory: number
    sql: number
    http: number
    es: number
    cache: number
    redis: number
    apcu: number
    mongo: number
    queue: number
    al: number
    ct: number
    fio: number
}

export const createDateRangeTrend = (
    report: Report<AbstractHistogram | null>,
    days: string[],
    service: string,
    noData: boolean,
): DateRangeTrend => {
    const [start, ...restDays] = days
    const end = restDays.length === 0 ? start : restDays.pop()

    const range = { startDate: start + ' 00:00:00', endDate: end + ' 23:59:59' }

    if (noData) {
        return {
            range,
            errorRate: 0,
            requests: 0,
            crawlers: 0,
            pageCache: { hits: 0, misses: 0 },
            responseTime: 0,
            averageResponseTime: 0,
            phpResponseTime: 0,
            maxMemory: 0,
            sql: 0,
            http: 0,
            es: 0,
            cache: 0,
            redis: 0,
            apcu: 0,
            mongo: 0,
            queue: 0,
            al: 0,
            ct: 0,
            fio: 0,
        }
    }

    const slice = report.slices[Object.keys(report.slices)[0]]

    if (!slice) {
        throw Error(`no slice for service ${service}`)
    }
    return {
        range,
        errorRate: slice.errorRate,
        requests: slice.requests,
        crawlers: slice.crawlers,
        pageCache: { hits: slice.pageCache.hits, misses: slice.pageCache.misses },
        responseTime: report.histogram ? report.histogram.getValueAtPercentile(95) : slice.responseTime,
        averageResponseTime: slice.average || 0,
        phpResponseTime: layersPhpResponseTime(slice.average || 0, slice.downstream),
        maxMemory: slice.memory || 0,
        sql: slice.downstream.sql || 0,
        http: slice.downstream.http || 0,
        es: slice.downstream.es || 0,
        cache: slice.downstream.cache || 0,
        redis: slice.downstream.redis || 0,
        apcu: slice.downstream.apcu || 0,
        mongo: slice.downstream.mongo || 0,
        queue: slice.downstream.queue || 0,
        al: slice.downstream.al || 0,
        ct: slice.downstream.ct || 0,
        fio: slice.downstream.fio || 0,
    }
}
